import gql from 'graphql-tag'
import { main } from './fragments'

export default gql`
mutation createProductGroup($required: ProductGroupReqFields!) {
	cashAssist {
		createMutation: createProductGroup(required: $required) {
			...productGroupMain
		}
	}
}
${main}`
